import * as React from "react";
import { forwardRef } from "react";
const SvgVector = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 21, fill: "none", viewBox: "0 0 32 21", ref, ...props }, /* @__PURE__ */ React.createElement("path", { stroke: "#2B353A", strokeLinecap: "round", strokeWidth: 2.056, d: "M1.747 10.35h28.787m0 0-9.253-9.254m9.253 9.253-9.253 9.253" }));
const ForwardRef = forwardRef(SvgVector);
export { ForwardRef as ReactComponent };
